module.exports = __webpack_public_path__ + "media/site_templates/www.waterproofing.net.au/images/testimonials-849ea527b1ab6eba12aae19a149779fb.jpg";